<template>
    <OverlayLoader :isLoading="!clientsLoaded || !userLoaded">
        <main class="page page-dashboard">
            <div class="container">

                <PageHeader
                    :title="$translate.text('general.dashboard')"
                    icon="fal fa-search"
                    @catchEmit="toggleSearch"
                />

                <badger-accordion class="accordion-table" :icons="false">
                    <div class="tr">
                        <span class="tr-column">{{ t('resellers.dashboard.table.company') }}</span>
                        <span class="tr-column">{{ t('resellers.dashboard.table.webshops') }}</span>
                        <span class="tr-column">{{ t('resellers.dashboard.table.feeds') }}</span>
                        <span class="tr-column">{{ t('resellers.dashboard.table.connections') }}</span>
                        <span class="tr-column">{{ t('resellers.dashboard.table.subscriptions') }}</span>
                        <span class="tr-column">{{ t('resellers.dashboard.table.status') }}</span>
                        <span class="tr-column"></span>
                    </div>
                    <badger-accordion-item v-for="(client, index) in clients" :key="index">
                        <template slot="header">
                            <div class="info">
                                <span class="info-column" >{{ client.company_name }}</span>
                                <span class="info-column">{{ client.webshops }}</span>
                                <span class="info-column">{{ client.feeds }}</span>
                                <span class="info-column">{{ client.connections }}</span>
                                <span class="info-column" v-if="client.subscription !== null">{{ clientSub(client.subscription) }}</span>
                                <span class="info-column" v-else></span>
                                <span class="info-column"> {{ client.status }}</span>
                                <div class="info-column actions">
                                    <i v-if="!client.invite_accepted" @click="resendInvitation(client)" class="fal fa-paper-plane"></i>
                                    <!-- <i class="fal fa-edit table-action-btn" v-tooltip.bottom="$translate.text('tooltip.edit')"></i> -->
                                    <i class="fal fa-sign-in" v-if="client.active" @click="loginAsClient(client.id)" v-tooltip.bottom="$translate.text('tooltip.login_as')"></i>
                                    <i class="fal fa-user-check" v-if="!client.active && client.invite_accepted" @click="deactivateClient(client.id)" v-tooltip.bottom="$translate.text('tooltip.activate')"></i>
                                    <i class="fal fa-user-slash table-action-btn" v-if="client.active" @click="deactivateClient(client.id)" v-tooltip.bottom="$translate.text('tooltip.deactivate')"></i>
                                    <i class="fal fa-trash-alt table-action-btn" @click="deleteClient(client.id)" v-tooltip.bottom="$translate.text('tooltip.delete')"></i>
                                </div>
                            </div>
                        </template>
                        <template slot="content" v-if="client.active">
                            <div class="info-column" v-if="!client.invite_accepted">
                                <div class="invite-pending">
                                    <h5>{{ t('general.invitation.invited') }}</h5>
                                    <p>{{ t('general.invitation.send_to') }} {{ client.email }}</p>

                                    <div class="button-group" v-if="user.id !== 4">
                                        <button class="button button--rounded" @click="reSendMail(client)">{{ t('general.resend_invitation') }}</button>
                                        <button class="button button--rounded button--ghost" @click="resendOtherEmail(client)">{{ t('general.resend_invitation.other_email') }}</button>
                                    </div>
                                </div>
                            </div>

                            <div v-else class="info-column">
                                <div class="customers-content">
                                    <div class="customers-content--block">
                                        <h5>{{ t('general.company_information') }}</h5>
                                        <p>{{ client.company_name }}</p>
                                        <p>{{ client.street }}</p>
                                        <p>{{ client.zipcode }}, {{ client.city }}</p>
                                        <p>{{ client.phone }}</p>
                                        <p>{{ client.website }}</p>
                                    </div>

                                    <div class="customers-content--block">
                                        <h5>{{ t('general.contact_information') }}</h5>
                                        <p>{{ client.contact_name }}</p>
                                        <p>{{ client.phone }}</p>
                                        <p>{{ client.email }}</p>
                                    </div>

                                    <div class="customers-content--block">
                                        <h5>{{ t('general.extra_information') }}</h5>
                                        <p>{{ client.kvk }}</p>
                                        <p>{{ client.btw }}</p>
                                    </div>

                                    <div class="customers-content--block">
                                        <h5>{{ t('auth.login_as.client') }}</h5>
                                        <button class="button button--rounded" @click="loginAsClient(client.id)">{{ t('auth.login') }}</button>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </badger-accordion-item>

                    <div class="accordion-table--empty" v-if="!clients.length">
                        <p>{{ t('resellers.dashboard.table.empty') }}</p>
                    </div>
                </badger-accordion>

            </div>
            <FloatingButton
                @clicked="$router.push({ name: 'Resellers Clients Add' })"
            />
        </main>
    </OverlayLoader>
</template>
<script>
// Globabl imports
import { BadgerAccordion, BadgerAccordionItem } from 'vue-badger-accordion';
import swal from 'sweetalert';

import OverlayLoader from '@/components/OverlayLoader/OverlayLoader';
import { get, post, remove } from '@/helpers/http';
import { getUser } from '@/helpers/auth';
import handleError from '@/helpers/error';
import { validEmail } from '@/helpers/validator';
import Ghost from '@/classes/Ghost';

import PageHeader from '@/components/PageHeader/PageHeader';
import FloatingButton from '@/components/FloatingButton/FloatingButton';

export default {
    name: 'Resellers',

    components: {
        PageHeader,
        FloatingButton,
        BadgerAccordion,
        BadgerAccordionItem,
        OverlayLoader,
    },


    data() {
        return {
            clients: [],
            clientsLoaded: false,

            filters: {
                search: null,
            },

            user: {},
            userLoaded: false,

        };
    },

    created() {
        this.getClients();
        this.getAccountInfo();
    },

    methods: {
        clientSub(sub) {
            if (sub === null) {
                return '';
            }
            return sub.subscribed_till;
        },
        getAccountInfo() {
            this.user = getUser();
            this.userLoaded = true;
        },

        resendInvitation(client) {
            swal(
                this.$translate.text('alert.confirm.invitation.resend'),
                {
                    buttons: {
                        cancel: this.$translate.text('general.no'),
                        confirm: this.$translate.text('general.yes'),
                    },
                },
            ).then((value) => {
                if (value) {
                    post({
                        url: `${this.$API_URL}/api/resellers/clients/${client.id}/invite/resend`,
                    })
                        .then(() => {
                            swal({
                                title: this.$translate.text('alert.title.invitation.resend'),
                                text: `${this.$translate.text('general.invitation.send_to')}: ${client.email}`,
                                buttons: {
                                    confirm: {
                                        text: this.$translate.text('general.ok'),
                                    },
                                },
                            });
                        })
                        .catch((error) => {
                            handleError({
                                error,
                                message: this.$translate.text('alert.whoops'),
                            });
                        });
                }
            });
        },

        deleteClient(id) {
            swal(
                this.$translate.text('alert.confirm.delete'),
                {
                    buttons: {
                        cancel: this.$translate.text('general.no'),
                        confirm: this.$translate.text('general.yes'),
                    },
                },
            ).then((value) => {
                if (value) {
                    remove({
                        url: `${this.$API_URL}/api/resellers/clients/${id}`,
                    })
                        .then(() => {
                            this.clientsLoaded = false;
                            this.getClients();
                        })
                        .catch((error) => {
                            handleError({
                                error,
                                message: this.$translate.text('alert.whoops'),
                            });
                        });
                }
            });
        },

        deactivateClient(id) {
            swal(
                this.$translate.text('alert.confirm.client.change'),
                {
                    buttons: {
                        cancel: this.$translate.text('general.no'),
                        confirm: this.$translate.text('general.yes'),
                    },
                },
            ).then((value) => {
                if (value) {
                    post({
                        url: `${this.$API_URL}/api/resellers/clients/${id}/toggle`,
                    })
                        .then(() => {
                            this.clientsLoaded = false;
                            this.getClients();
                        })
                        .catch((error) => {
                            handleError({
                                error,
                                message: this.$translate.text('alert.whoops'),
                            });
                        });
                }
            });
        },

        toggleSearch(event) {
            if (event === '') {
                event = null;
            }
            this.clientsLoaded = false;

            this.filters.search = event;
            this.getClients();
        },

        loginAsClient(clientId) {
            // Get UserID based on clientId
            Ghost.login({
                type: 'Client',
                id: clientId,
            })
                .then(() => this.$router.go())
                .catch((error) => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        getClients() {
            let search = '';
            if (this.filters.search !== null) {
                search = `&search=${this.filters.search}`;
            }

            get({
                url: `${this.$API_URL}/api/resellers/clients?paginate=1000${search}`,
            })
                .then((response) => {
                    this.clients = response.data.data;
                    this.clientsLoaded = true;
                })
                .catch((error) => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        reSendMail(client) {
            post({
                url: `${this.$API_URL}/api/resellers/clients/invite/${client.id}/resend`,
                data: {
                    client_id: client.id,
                    email: client.email,
                },
            })
                .then(() => {
                    swal({
                        title: this.$translate.text('alert.title.invitation.resend'),
                        text: this.$translate.text('general.invitation.send_to') + client.email,
                    });
                })
                .catch((error) => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        subscripted_status(client) {
            if (client.payment_information !== undefined && client.payment_information !== null) {
                if (new Date(client.payment_information.subscribed_till) > new Date()) {
                    return this.$translate.text('general.active');
                }
                return this.$translate.text('general.inactive');
            }
            return this.$translate.text('general.inactive');
        },

        subscripted(client) {
            if (client.payment_information !== undefined && client.payment_information !== null) {
                if (client.payment_information.subscribed_till !== null) {
                    // eslint-disable-next-line
                    return new Date(client.payment_information.subscribed_till).toISOString().slice(0, 10) + ` ( ${client.payment_information.type} )`;
                }
                return '';
            }
            return '';
        },

        resendOtherEmail(client) {
            const translationString = this.$translate.text('general.resend_invitation.explanation');

            swal({
                title: this.$translate.text('general.resend_invitation'),
                text: translationString.replace('%x', client.email),
                content: {
                    element: 'input',
                    attributes: {
                        type: 'email',
                    },
                },
                buttons: {
                    cancel: this.$translate.text('general.cancel'),
                    confirm: {
                        text: this.$translate.text('general.resend_invitation'),
                    },
                },
                closeOnEsc: false,
            })
                .then(value => {
                    // if user clicked the modal away or the close button
                    if (value === null) return null;

                    // Check if the email filled in is a valid email.
                    if (!validEmail(value)) return false;

                    // its all valid so continue with the value
                    return value;
                })
                .then(email => {
                    // Since it will always go to the next then check what previous result was.
                    if (email != null) {
                        // check if the value is correct from the previous then
                        if (email === false) {
                            swal({
                                title: this.$translate.text('alert.whoops'),
                                text: this.$translate.text('alert.whoops.message.invalid_email'),
                            })
                                .then(() => {
                                    this.resendOtherEmail();
                                });
                        } else {
                            // Make the call
                            post({
                                url: `${this.$API_URL}/api/resellers/clients/invite/${client.id}/resend`,
                                data: {
                                    client_id: client.id,
                                    email,
                                },
                            })
                                .then(() => {
                                    swal({
                                        title: this.$translate.text('alert.title.invitation.send'),
                                        text: this.$translate.text('general.invitation.send_to') + email,
                                    });
                                })
                                .catch((error) => {
                                    handleError({
                                        error,
                                        message: this.$translate.text('alert.whoops'),
                                    });
                                });
                        }
                    }
                });
        },
    },
};
</script>
<style lang="scss" scoped>
h4 {
    margin-bottom: 64px;
}

.deactivated {
    color: $text-grey;
}

.table-action-btn {
    border: 0;
    font-size: 1.25rem;
    outline: 0;

    &:hover {
        cursor: pointer;
    }
}

.info-content {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr;
    grid-column-gap: 0px;
    grid-row-gap: 0px;
}
span.badger-toggle-indicator {
    display: none !important;
}

.customers-content {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 8px;
    padding: 16px;

    @media(min-width: 992px) {
        grid-template-columns: 1fr 1fr;
    }

    @media(min-width: 1200px) {
        grid-template-columns: 1fr 1fr 1fr 1fr;
    }

    h5, p {
        margin-bottom: 8px;
    }
}
</style>
